export default __webpack_public_path__ + "static/media/logo.55fbd2d1.svg";